import { BaseTag }   from "mixs/base/base_mixin";
import moment from 'moment';
export class Global {
  public static getData(){
    return App.store.getState().data
  }
  public static dataScopeHistory(id){       return 'history_' + id; }
  public static dataScopePhase(id){         return 'phase_' + id; }
  public static dataScopeProduct(id){       return 'product_' + id; }
  public static dataScopeClient(id){        return 'client_' + id; }
  public static dataScopeUser(id){          return 'user_' + id; }
  public static dataScopeTeam(id){          return 'team_' + id; }
  public static dataScopeLocation(id){      return 'location_' + id; }
  //
  public static getHistoryData(id){    return this.getData()[this.dataScopeHistory(id)]; }
  public static getPhaseData(id){      return this.getData()[this.dataScopePhase(id)]; }
  public static getProductData(id){    return this.getData()[this.dataScopeProduct(id)]; }
  public static getClientData(id){     return this.getData()[this.dataScopeClient(id)]; }
  public static getUserData(id){       return this.getData()[this.dataScopeUser(id)]; }
  public static getTeamData(id){       return this.getData()[this.dataScopeTeam(id)]; }
  public static getLocationData(id){   return this.getData()[this.dataScopeLocation(id)]; }
}
export class HistoriesBase extends BaseTag {
  straight(value){
    return value;
  }
  phaseName(id){
    if(id == undefined){ id = this.opts.json.phase_id }
    let data = Global.getPhaseData(id)
    if(data == undefined) { return '**' }
    return data.name
  }
  phaseColorCode(id){
    if(id == undefined){ id = this.opts.json.phase_id }
    let data = Global.getPhaseData(id)
    if(data == undefined) { return '' }
    return data.colorcode;
  }
  productName(id){
    let data = Global.getProductData(id);
    if(data == undefined) { return '**' }
    return data.fullname
  }
  clientName(id){
    let data = Global.getClientData(id);
    if(data == undefined) { return '**' }
    return data.fullname
  }
  userName(id){
    if(id == undefined){ id = this.opts.user_id }
    let data = Global.getUserData(id);
    if(data == undefined) { return '**' }
    return data.name
  }
  dateFormat(dateStr){
    if(dateStr == null || dateStr == ''){ return '' }
    let m = moment(dateStr)
    return m.format('YYYY-MM-DD')
  }
  datetimeFormat(dateStr){
    if(dateStr == null || dateStr == ''){ return '' }
    let m = moment(dateStr)
    return m.format('YYYY-MM-DD HH:mm')
  }
  responsibleName(id, type){
    if(!id){ return ''; }
    if(!type){ return ''; }
    let data = undefined;
    if(type == 'Team'){
      data = Global.getTeamData(id)
    } else if (type == 'User'){
      data = Global.getUserData(id)
    }
    if(data == undefined) { return '**' }
    return data.name
  }
  locationName(id){
    if(!id){ return ''; }
    let data = Global.getLocationData(id);
    if(data == undefined) { return '**' }
    return data.name;
  }
  under(integer){
    return this.locale().labels['under_' + integer];
  }
}
riot.mixin('histories.base', HistoriesBase as riot.TagMixin)
